import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {MainComponent} from './main.component';
import {MainRoutingModule} from './main-routing.module';
import {FeaturesModule} from '../features/features.module';
import {NavbarComponent} from '../core/navbar/navbar.component';
import {LoginComponent} from '../login/login.component';
import {AuthGuard} from '../auth-guard.service';
import {ApiService} from '../services/api.service';
import {AuthenticationService} from '../services/authentication.service';
import {HttpClientService} from '../services/http-client.service';
import {ValidateOtpComponent} from '../validate-otp/validate-otp.component';
import {TranslateModule} from '@ngx-translate/core';
import {SessionService} from '../services/session.service';

@NgModule({
  imports: [
    CommonModule,
    MainRoutingModule,
    FeaturesModule,
    RouterModule,
    FormsModule,
    HttpClientModule,
    NgbModule,
    TranslateModule
  ],
  declarations: [
    MainComponent,
    NavbarComponent,
    LoginComponent,
    ValidateOtpComponent,
  ],
  providers: [
    AuthGuard,
    ApiService,
    AuthenticationService,
    HttpClientService,
    SessionService,
  ]
})
export class MainModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/main/main.module.ts